import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';


/**
 * Hidden file input UI
 * It's role is to open a file input window on command, and emit selected files
 */
@Component({
    selector: 'app-hidden-upload-input',
    imports: [],
    template: ` <input
    #fileInput
    (change)="onFileInputChange($event)"
    [multiple]="allowMultipleFiles"
    [accept]="acceptFileTypes"
    class="upload disp-none"
    type="file"
  />`,
    styles: []
})
export class UploadHiddenInputComponent {
  @ViewChild('fileInput') fileElement: ElementRef<HTMLInputElement>;
  @Input() acceptFileTypes = '*';
  @Input() allowMultipleFiles = false;
  @Input() allowSameFileUpload = true; // allows upload of a file with same name
  /**
   * Emits selected files as an array of File objects
   */
  @Output() filesChange = new EventEmitter<File[]>();

  /**
   * Emits raw change event as it is received from the file input
   * Useful in cases where you need to access the file input event object directly e.g. profile picture cropper
   */
  @Output() filesChangeRaw = new EventEmitter<Event>();

  onFileInputChange(event: Event) {
    const files: File[] = this.convertInputEventToFileArray(event);

    this.filesChangeRaw.emit(event);
    this.filesChange.emit(files);

    if (this.allowSameFileUpload) {
      const target = event.target as HTMLInputElement;
      target.value = ''; // allow re-upload of the same files
    }
  }

  openFileUploadWindow() {
    this.fileElement.nativeElement.click();
  }

  private convertInputEventToFileArray(event: Event): File[] {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files?.length > 0) {
      return Array.from(target.files);
    }
    return [];
  }
}
